import { FilterGroup } from "../../services/Alert";
import { checkErrors, getDefaultOptions } from "../../services/Category";
import { GenericObject } from "../../services/Price";
import { FilterDimension, Kpi, KpiFormat } from "./FilterType";

export const computeValue = ({
  options,
  value,
}: {
  options: KpiFormat;
  value: number;
}) => {
  if (options?.multiply) {
    // value is [0, 1] so we multiply per 100 to display percent
    return value * 100;
  }
  if (options?.round) {
    return Math.round(value);
  }
  return value;
};

export const uncomputeValue = ({
  options,
  value,
}: {
  options: KpiFormat;
  value: number;
}) => {
  if (options?.multiply) {
    // value is [0, 1] so we multiply per 100 to display percent
    return value / 100;
  }
  return value;
};

export const valueDeserialize = (column: Kpi, value: string) => {
  return uncomputeValue({
    options: column.format,
    value: parseInt(value),
  });
};

export const valueSerialize = (column: Kpi, value: number): string => {
  return computeValue({
    options: column.format,
    value: value,
  }).toString();
};

export const getDefaultGroup = (
  name: string,
  type: "kpi" | "perimeter" | "table"
) => {
  return {
    favorite: false,
    name: name,
    type: type,
    filters: [] as FilterDimension[],
  } as FilterGroup;
};

export const getCalculationSimulationResult = async (
  api: string,
  input: string,
  inputVariables: GenericObject,
  roundingValues: GenericObject
) => {
  const url = new URL(api, window.origin);
  const data = Object.assign(
    { user_input: input },
    Object.assign(roundingValues, inputVariables)
  );
  const response = await fetch(
    url.toString(),
    getDefaultOptions({ method: "POST", body: JSON.stringify(data) })
  );
  checkErrors(response);
  return response.json();
};
